import React from "react";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

const variants = {
  neutral:
    "border-slate-200 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800",
  primary:
    "border-sky-200 bg-sky-50 text-sky-700 hover:bg-sky-100 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-300 dark:hover:bg-sky-500/20",
  danger:
    "border-red-200 bg-red-50 text-red-700 hover:bg-red-100 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300 dark:hover:bg-red-500/20",
};

export default function AdminIconButton({
  type = "button",
  icon: Icon,
  label,
  title,
  badge,
  onClick,
  variant = "neutral",
  className = "",
  iconClassName = "",
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      title={title || label}
      className={cn(
        "relative inline-flex h-11 items-center justify-center gap-2 rounded-2xl border px-3 text-sm font-bold shadow-sm transition active:scale-[0.98]",
        label ? "min-w-11" : "w-11 px-0",
        variants[variant] || variants.neutral,
        className,
      )}
    >
      {Icon ? <Icon className={cn("text-base", iconClassName)} /> : null}

      {label ? <span className="hidden sm:inline">{label}</span> : null}

      {badge > 0 ? (
        <span className="absolute -right-1.5 -top-1.5 flex min-h-[20px] min-w-[20px] items-center justify-center rounded-full bg-red-600 px-1.5 text-[10px] font-bold text-white ring-2 ring-white dark:ring-slate-950">
          {badge > 99 ? "99+" : badge}
        </span>
      ) : null}
    </button>
  );
}